module.exports = __webpack_public_path__ + "8e003a1b5bd3f2dadb7e270cb27b39c2.MP3";